import type { ReactNode } from "react";

export const NO_REPLAY_ATTRIBUTE = "data-tc-no-replay";

/** Marks a private page (checkout, pay, confirmation, account) for the
 *  agency's PostHog: replay is blocked inside it at capture time and stopped
 *  while it is on screen (`posthog-agency.ts`). `display: contents` keeps the
 *  wrapper out of layout. */
export function NoReplay({ children }: { children: ReactNode }) {
  return (
    <div {...{ [NO_REPLAY_ATTRIBUTE]: "" }} style={{ display: "contents" }}>
      {children}
    </div>
  );
}
